import React from "react";
import { useTranslation } from "react-i18next";
import MotivatorsList from "../components/motivators/MotivatorsList"

function PrizeGames() {
  const { t } = useTranslation();
  return (

    <div id="artur-profilePrizeGame">
      <div className="container">
        <div className="row">
        <div className="col-md-12 col-md-offset-2 content">
         {/* <a className="howTo" href={t("admin.common.worksMoUrl")} target="_blank" rel="noreferrer">{t("products.works")}</a>*/}
          <h2>{t("admin.prize.moti")}<span className="gift" /></h2>
          <MotivatorsList/>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrizeGames;